"use client"

import React, { useState, useEffect, useRef, useCallback } from 'react';
import apiService from '../services/apiService';
import { useLogout } from '../hooks/useLogout';
import { useSidebar } from '../hooks/useSidebar';
import { CriticalAlertsHeader } from '../components/ui/critical-alerts-header';
import { CriticalAlerts, CriticalAlertsRef } from '../components/ui/critical-alerts';
import { CustomOverlaySidebar } from '../components/ui/custom-overlay-sidebar';
import { GATEWAY_FAILURE_TYPES } from '../constants/alertTypes';

const OFFLINE_CHECK_INTERVAL_MS = 60_000;

const GatewayAlertsPage: React.FC = () => {
  const { sidebarOpen, closeSidebar, toggleSidebar } = useSidebar();
  const handleLogout = useLogout();
  const [filters, setFilters] = useState({
    failureType: "all",
    severity: "all",
    status: "all",
    startTime: "",
    endTime: "",
  });
  const alertsRef = useRef<CriticalAlertsRef>(null);

  const runOfflineCheck = useCallback(async () => {
    const response = await apiService.checkGatewayOffline();
    if (response.success && (response.data as any)?.alerts_created > 0) {
      alertsRef.current?.refreshAlerts();
    }
  }, []);

  useEffect(() => {
    runOfflineCheck();
    const interval = setInterval(runOfflineCheck, OFFLINE_CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [runOfflineCheck]);


  const handleFiltersChange = (newFilters: typeof filters) => {
    setFilters(newFilters);
  };

  const handleStatusFilterChange = (status: string) => {
    setFilters(prev => ({ ...prev, status }));
  };

  return (
    <div style={{ backgroundColor: "#0f0f0f", minHeight: "100vh" }}>
      {/* Custom Overlay Sidebar */}
      <CustomOverlaySidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      {/* Main Content - Full Width */}
      <div className="w-full min-h-screen">
        <CriticalAlertsHeader
          onLogout={handleLogout}
          onSidebarToggle={toggleSidebar}
          onFiltersChange={handleFiltersChange}
          title="Gateway Alerts"
          failureTypeOptions={GATEWAY_FAILURE_TYPES}
          theme="gateway"
          externalStatus={filters.status}
        />
        <div className="p-6">
          <CriticalAlerts
            ref={alertsRef}
            filters={filters}
            sourceType="gateway"
            onStatusFilterChange={handleStatusFilterChange}
          />
        </div>
      </div>
    </div>
  );
};

export default GatewayAlertsPage;
